/**
 * Job List Configuration Constants
 */

/**
 * Polling interval for job updates (in milliseconds)
 * Used to refresh job data while preprocessing is active
 */
export const POLLING_INTERVAL = 10000; // 10 seconds

/**
 * Sheet data fetch interval (in milliseconds)
 * Used to refresh sheet data until column descriptions are available
 */
export const SHEET_FETCH_INTERVAL = 5000; // 5 seconds

/**
 * Number of jobs to fetch per page
 * Used in infinite scroll pagination
 */
export const JOBS_PAGE_SIZE = 2000;

/**
 * Root margin for infinite scroll intersection observer
 * Starts loading earlier when scrolling large lists
 */
export const INFINITE_SCROLL_ROOT_MARGIN = "0px 0px 800px 0px";

/**
 * Threshold for infinite scroll intersection observer
 * Triggers when 20% of the target element is visible
 */
export const INFINITE_SCROLL_THRESHOLD = 0.2;

/**
 * Default group key for ungrouped or unspecified items
 */
export const DEFAULT_GROUP_KEY = "Not specified";

/**
 * Special column names that come from the job object itself
 * rather than from sheet data
 */
export const JOB_OBJECT_COLUMNS = {
  GARMENT_TYPE: "garment_type",
} as const;
